/* Being Jaini native checkout: no AJAX cart refreshes, checkout locks or hidden checkout states.
   Shopify's native cart form owns quantities, totals and checkout. */
(() => {
  'use strict';
  const cartURL = (window.Shopify?.routes?.root || '/') + 'cart';
  window.BJCart = { open: () => window.location.assign(cartURL) };

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-bj-qty-step]');
    if (!step) return;
    event.preventDefault();
    const quantity = step.closest('.bj-quantity-stepper')?.querySelector('[data-bj-cart-quantity]');
    if (!quantity || quantity.disabled) return;
    const current = Number(quantity.value), change = Number(step.dataset.bjQtyStep);
    if (!Number.isSafeInteger(current) || current < 0 || !Number.isSafeInteger(change)) {
      quantity.focus();
      return;
    }
    const next = Math.max(0, current + change);
    if (next === current) return;
    quantity.value = String(next);
    const form = quantity.closest('form');
    const update = form?.querySelector('[data-bj-native-update]');
    if (form && update) form.requestSubmit(update);
  });
})();
